<template>
  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/store/store/add'">添加门店</el-button>
        <el-form-item label="名称">
          <el-input size="small"  clearable  v-model="formInline.search" placeholder="门店名称"></el-input>
        </el-form-item>
        <el-form-item label="门店区域">
          <el-select v-model="formInline.province_id" placeholder="省" @change="initCity" clearable>
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
          </el-select>
          <el-select v-if="formInline.province_id!=''" v-model="formInline.city_id" placeholder="市" @change="initRegion" clearable>
            <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[formInline.province_id]['city']"
              :key='index1'></el-option>
          </el-select>
          <el-select v-if="formInline.city_id!=''" v-model="formInline.region_id" placeholder="区" clearable>
            <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[formInline.province_id]['city'][formInline.city_id]['region']"
              :key='index2'></el-option>
          </el-select>

        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
          
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="store_id" label="门店ID" width="60"></el-table-column>
          <el-table-column label="Logo" width="60">
            <template slot-scope="scope">
              <img v-img-url="scope.row.logo.file_path" width="30px" height="30px" />
            </template>
          </el-table-column>
          <el-table-column prop="store_name" label="门店名称"></el-table-column>
          <el-table-column prop="shop_hours" label="营业时间"></el-table-column>
          <el-table-column prop="linkman" label="联系人"></el-table-column>
          <el-table-column prop="phone" label="联系电话" width="100"></el-table-column>
          <el-table-column prop="detail_address" label="门店地址" width="240"></el-table-column>
          <el-table-column prop="is_check" label="自提核销">
            <template slot-scope="scope">
              <span :class="{ green: scope.row.is_check.value == 1, gray: scope.row.is_check.value == 0 }">{{ scope.row.is_check.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="门店状态">
            <template slot-scope="scope">
              <span :class="{ green: scope.row.status.value == 1, gray: scope.row.status.value == 0 }">{{ scope.row.status.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="140"></el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button @click="subscribeClick(scope.row)" type="text" size="small" v-if="show_subscribe">预约管理</el-button>
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/store/store/edit'">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/store/store/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <Subscribe v-if="subscribe_open" :open_edit="subscribe_open" :form="formModel" @closeDialog="closeDialogFunc($event)"></Subscribe>
  </div>
</template>

<script>
import StoreApi from '@/api/store.js';
import DataApi from '@/api/data.js';
import Subscribe from './part/Subscribe.vue';
export default {
  components: {
    Subscribe
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      areaList:[],
      /*横向表单数据模型*/
      formInline: {
        search: '',
        province_id:'',
        city_id:'',
        region_id:'',
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      subscribe_open: false,   //预约管理
      /*当前编辑的对象*/
      userModel: {},
      show_subscribe: false, //是否显示预约管理
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
    this.getAreas();
    if(this.$filter.isAuth('/store/store/subscribe') && this.$filter.isAuth('/service')) this.show_subscribe = true;
  },
  methods: {
      getAreas(){
        let self = this;
        DataApi.getArea({}, true)
          .then(res => {
            self.areaList = res.data.regionData;
          })
          .catch(error => {});
      },
    /*初始化城市id*/
      initCity() {
        this.formInline.city_id = ''
        this.formInline.region_id = ''
      },

      /*初始化区id*/
      initRegion() {
        this.formInline.region_id = ''
      },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    onSubmit(){
      this.loading = true;
      this.curPage = 1;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      StoreApi.shoplist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick() {
      this.$router.push('/store/store/add');
    },

    /*打开编辑*/
    editClick(row) {
      let self = this;
      let params = row.store_id;
      this.$router.push({
        path: '/store/store/edit',
        // name: 'mallList',
        query: {
          store_id: params
        }
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          StoreApi.deleteShop(
            {
              store_id: row.store_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: '恭喜你，门店删除成功',
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    /*打开预约管理*/
    subscribeClick(row) {
      this.formModel = row
      this.subscribe_open = true;
    },
    /*关闭预约管理*/
    closeDialogFunc(e) {
      this.subscribe_open = e.openDialog;
      this.getTableList()
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/store/store/index.vue